import { RouterProvider } from "react-router";
import { CssBaseline, GlobalStyles, ThemeProvider } from "@mui/material";
import { createTheme } from "@mui/material/styles";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers-pro";

import { AppContextProvider } from "@/common/appContext/AppContext";
import lightTheme from "@/ui/theme/lightTheme";
import { setChartTheme } from "@/ui/utilities/chartTheme";

import "@/common/platform/mui-x";

import { router } from "./configurations/router";
import Notifications from "./features/notifications/Notifications/Notifications";
import { ADMIN_PLATFORM } from "./appPlatform";

import "@/apps/admin/assets/fonts/cera.css";

const theme = createTheme(lightTheme, {
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
        },
      },
    },
  },
});

// Charts (Genie's chart blocks) draw with the light theme, as layout's do in light mode.
setChartTheme(lightTheme);

const App = () => {
  return (
    <AppContextProvider platform={ADMIN_PLATFORM}>
      <ThemeProvider theme={theme}>
        <CssBaseline>
          <Notifications />
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <RouterProvider router={router} />
          </LocalizationProvider>
        </CssBaseline>
        <GlobalStyles styles={{ body: { backgroundColor: "#fafafa" } }} />
      </ThemeProvider>
    </AppContextProvider>
  );
};

export default App;
